export const pl = {
  'Homepage': 'Strona główna',
  'Main Dashboard': 'Główny panel',
  'Inventory Dashboard': 'Panel inwentarza',
  'Chat': 'Czat',
  'Shelf Planner': 'Planer półek',
  'Reports': 'Raporty',
  'Catalog': 'Katalog',
  'Stored Items': 'Przechowywane przedmioty',
  'Replenishments': 'Uzupełnienia',
  'Expired': 'Przeterminowane',
  'Transfers': 'Transfery',
  'In Progress': 'W trakcie',
  'Cancelled': 'Anulowane',
  'Suspended': 'Zawieszone',
  'Customers': 'Klienci',
  'Goods In': 'Przyjęcie towaru',
  'All': 'Wszystkie',
  'PTL Rack': 'Regał PTL',
  'Cross-Docking': 'Cross-Docking',
  'Resources': 'Zasoby',
  'Shelf Maps': 'Mapy półek',
  'Warehouses & Zones': 'Magazyny i strefy',
  'Import/Export': 'Import/Eksport',
  'Units of Measure': 'Jednostki miary',
  'Smart Tags': 'Inteligentne etykiety',

  'Login': 'Logowanie do WMS360',
  'Please enter your credentials to sign in!': 'Proszę wprowadzić swoje dane logowania, aby się zalogować!',
  'Email': 'E-mail',
  'Password': 'Hasło',
  'Remember Me': 'Zapamiętaj mnie',
  'Forgot Password?': 'Zapomniałeś hasła?',
  'Signing in...': 'Logowanie...',
  'Sign In': 'Zaloguj się',
  'Incorrect email or password': 'Nieprawidłowy email lub hasło',

  'Forgot Password': 'Zapomniałeś hasła',
  'Check your email': 'Sprawdź swoją pocztę e-mail',
  'We have sent a password recovery instruction to your email': 'Wysłaliśmy instrukcję odzyskiwania hasła na Twój adres e-mail',
  'Please enter your email address to receive a verification code': 'Proszę podać swój adres e-mail, aby otrzymać kod weryfikacyjny',
  'Resend Email': 'Wyślij email ponownie',
  'Send Email': 'Wyślij email',
  'Back to': 'Powrót do',
  'Sign in': 'Zaloguj się',
  'Reset done': 'Resetowanie zakończone',
  'Your password has been successfully reset': 'Twoje hasło zostało pomyślnie zresetowane',
  'Set new password': 'Ustaw nowe hasło',
  'Your new password must different to previous password': 'Twoje nowe hasło musi różnić się od poprzedniego',
  'Confirm Password': 'Potwierdź hasło',

  'Submitting ...': 'Przesyłanie...',
  'Submit': 'Prześlij',
  'Continue': 'Kontynuuj',

  'Inventory': 'Inwentarz',
  'Dashboard': 'Panel',
  'Filter': 'Filtr',
  'Pick Confirmed': 'Wybór potwierdzony',
  'Sold': 'Sprzedane',
  'Short Items': 'Brakujące przedmioty',
  'Fix': 'Naprawić',
  'Status': 'Status',
  'Paid': 'Zapłacone',
  'Pending': 'Oczekujące',
  'Failed': 'Nieudane',
  'Date': 'Data',
  'Amount': 'Kwota',
  'Snapshot Variance Reports': 'Raporty różnic wynikających ze zdjęć',
  'Unique Items': 'Unikalne przedmioty',
  'Total Item Count': 'Całkowita liczba przedmiotów',
  'Stock Count': 'Inwentaryzacja',
  'Inbound Items': 'Przedmioty przychodzące',

  'Available': 'Dostępne',
  'Low Stock': 'Niski stan',
  'Out of Stock': 'Brak na stanie',
  'Total Stock': 'Całkowity stan magazynowy',

  'Value Distribution': 'Rozkład wartości',
  'Vertical': 'Windy',
  'Racking': 'Regały',
  'Quarantine': 'Kwarantanna',
  'Inspection': 'Inspekcja',

  'Variance Value': 'Wartość wariancji',
  'Warehouse Capacity': 'Pojemność magazynu',

  'Activities': 'Działania',
  'View All': 'Pokaż wszystkie',
  'No Activities': 'Brak działań',

  'Batch Cycles': 'Cykle partii',
  'Performance': 'Wydajność',
  'Staff': 'Personel',

  'Pending Jobs': 'Oczekujące zadania',
  'Completed Jobs': 'Zakończone zadania',
  'Put away': 'Przechowywanie',
  'Picks Completed': 'Wybory zakończone',
  'Active Staff': 'Aktywny personel',
  'Work Load': 'Obciążenie pracą',

  'Fulfilment Time (avg)': 'Średni czas realizacji',
  'Order': 'Zamówienie',
  'Total': 'Suma',
  'Latest Orders': 'Najnowsze zamówienia',
  'View Orders': 'Zobacz zamówienia',

  'Categories': 'Kategorie',

  'Orders Dashboard': 'Panel zamówień',
  'View your current sales & summary': 'Zobacz aktualne sprzedaże i podsumowanie',
  'Sales Report': 'Raport sprzedaży',
  'Export Report': 'Eksportuj raport',

  'Revenue': 'Przychody',
  'Orders': 'Zamówienia',
  'Purchases': 'Zakupy',

  'Processing': 'Przetwarzanie',
  'Return': 'Zwrot',
  'Units': 'Jednostki',
  'Scan Confirmed': 'Skan potwierdzony',

  'Top Selling': 'Najlepiej sprzedające się',
  'View Products': 'Zobacz produkty',
  'Article': 'Artykuł',
  'Title': 'Tytuł',
  'Quantity': 'Ilość',
  'Expired Date': 'Data ważności',

  'Product': 'Produkt',
  'Products': 'Produkty',
  'Warehouse': 'Magazyn',
  'Zone': 'Strefa',
  'Lift': 'Winda',
  'Lifts': 'Windy',
  'Lift Type': 'Typ windy',
  'Lift Types': 'Typy wind',
  'Lift Number': 'Numer windy',
  'Lift Name': 'Nazwa windy',
  'Shelf': 'Półka',
  'Shelves': 'Półki',
  'User': 'Użytkownik',
  'Users': 'Użytkownicy',
  'User name': 'Nazwa użytkownika',
  'Username': 'Nazwa użytkownika',
  'Access point': 'Punkt dostępu',
  'Barcode': 'Kod kreskowy',
  'Width': 'Szerokość',
  'Height': 'Wysokość',
  'Depth': 'Głębokość',
  'Depths': 'Głębokości',
  'Compartment': 'Przegroda',
  'Compartments': 'Przegrody',
  'Type': 'Typ',
  'S/C/D': 'S/C/D',
  'Created': 'Utworzono',
  'Color': 'Kolor',
  'Count': 'Liczba',
  'Counts': 'Liczenia',
  'Max': 'Maks',
  'Put': 'Włożono',
  'Pick': 'Wybierz',
  'Location': 'Lokalizacja',
  'Locations': 'Lokalizacje',
  'Description': 'Opis',
  'Pick Sheet': 'Arkusz wyboru',
  'Movements': 'Ruchy',
  'Movement': 'Ruch',
  'Job Name': 'Nazwa zadania',
  'Required Quantity': 'Wymagana ilość',
  'Actual Quantity': 'Rzeczywista ilość',
  'Other': 'Inne',
  'Bin': 'Pojemnik',
  'Bins': 'Pojemniki',
  'Setting': 'Ustawienie',
  'Settings': 'Ustawienia',
  'Max Qty.': 'Maks. ilość',

  'Filter by dates range': 'Filtruj według zakresu dat',
  'Min Qty.': 'Min. ilość',
  'Current Stock': 'Aktualny zapas',
  'Transfer': 'Transfer',
  'Add Product': 'Dodaj produkt',

  'No product found!': 'Nie znaleziono produktu!',
  'Add': 'Dodaj',
  'Cancel': 'Anuluj',
  'Save': 'Zapisz',
  'Edit': 'Edytuj',
  'Delete': 'Usuń',
  'Discard': 'Odrzuć',

  'Track #': 'Numer przesyłki',
  'Order Date': 'Data zamówienia',
  'Shipping Method': 'Metoda wysyłki',
  'Supplier': 'Dostawca',

  'Related Products': 'Powiązane produkty',
  'Consignment': 'Przesyłka',
  'Consigned': 'Wysłany',
  'Owner': 'Właściciel',
  'Search Owner': 'Szukaj właściciela',

  'Scan to pick': 'Skanuj do pobrania',
  'Active': 'Aktywny',
  'Block': 'Blokuj',
  'Pick Method': 'Metoda wyboru',
  'FIFO': 'FIFO',
  'Optimised': 'Zoptymalizowany',
  'Security': 'Bezpieczeństwo',
  'Stock Take': 'Inwentaryzacja',
  'Stock Valuation': 'Wycena zapasów',

  'Unit Of Measure': 'Jednostka miary',
  'Print Label on Pick': 'Drukuj etykietę przy pobieraniu',
  'Is Serialised': 'Jest seryjny',

  'Receiving': 'Odbiór',

  'This field is required': 'To pole jest wymagane',
  'Enter correct url!': 'Wprowadź poprawny URL!',
  'Something wrong! Can not upload file': 'Coś poszło nie tak! Nie można przesłać pliku',
  'Max quantity of the bins are required': 'Wymagana maksymalna ilość w pojemnikach',
  'Product successfully added': 'Produkt dodany pomyślnie',
  'article is existed.': 'Artykuł już istnieje.',
  'Error !!!': 'Błąd !!!',
  'Min Quantity': 'Min. ilość',
  'UOM': 'Jednostka miary',
  'Fifo': 'FiFo',
  'Pick multiplier': 'Mnożnik pobierania',
  'Put away multiplier': 'Mnożnik odkładania',
  'Buy Price': 'Cena zakupu',
  'Sell Price': 'Cena sprzedaży',
  'ERP Code': 'Kod ERP',
  'Manufacturer': 'Producent',
  'Model': 'Model',
  'Make': 'Marka',
  'Is serial numbered': 'Posiada numer seryjny',
  'H1': 'H1',
  'H2': 'H2',
  'H3': 'H3',
  'H4': 'H4',
  'H5': 'H5',
  'H6': 'H6',
  'Auto print label': 'Automatyczne drukowanie etykiet',
  'Scan pick': 'Skanowanie wyboru',
  'Product Image': 'Obraz produktu',
  'Please upload a image file!': 'Proszę przesłać plik obrazu!',
  'Upload image cannot more then {{size}}kb !': 'Przesyłany obraz nie może być większy niż {{size}}kb!',
  'Add or change image for the product': 'Dodaj lub zmień obraz produktu',
  'Drop your image here, or': 'Upuść obraz tutaj lub',
  'browse': 'przeglądaj',
  'Support: image files': 'Obsługa: pliki obrazów',
  'Use Webcam': 'Użyj kamery internetowej',
  'Capture photo': 'Zrób zdjęcie',
  'Are you sure you want to delete this product? All record related to this product will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć ten produkt? Wszystkie powiązane z nim dane zostaną również usunięte. Tej akcji nie można cofnąć.',
  'Delete product': 'Usuń produkt',

  'Counted': 'Policzone',
  'Completed': 'Zakończone',

  'Category': 'Kategoria',
  'Created At': 'Utworzono',
  'Started At': 'Rozpoczęto',
  'Completed At': 'Zakończono',
  'Item count': 'Liczba przedmiotów',
  'Value': 'Wartość',
  'Recounted': 'Przeliczono',
  'Variance': 'Różnica',
  'Approved': 'Zatwierdzono',

  'Checked': 'Sprawdzone',
  'Checked By': 'Sprawdził',
  'Checked Date': 'Data sprawdzenia',
  'Comment': 'Komentarz',
  'Sending ...': 'Wysyłanie...',
  'Send': 'Wyślij',
  'Recount All': 'Przelicz wszystko',
  'Approval All': 'Zatwierdź wszystko',
  'Matching': 'Dopasowanie',
  'Recount': 'Przeliczenie',

  'Count Name': 'Nazwa liczenia',
  'Cycle Count': 'Liczenie cykliczne',
  'Select the stock take group to count.': 'Wybierz grupę zapasów do policzenia.',
  'In which warehouse': 'W którym magazynie',
  'Should the articles being counted now be made inactive so they can not be picked or put until after they have been counted ?': 'Czy artykuły, które są teraz liczone, powinny zostać dezaktywowane, aby nie można było ich pobierać ani odkładać do czasu zakończenia liczenia?',
  'Cycle A': 'Cykl A',
  'Cycle B': 'Cykl B',
  'Cycle C': 'Cykl C',
  'No Count': 'Brak liczenia',

  'All Locations': 'Wszystkie lokalizacje',
  'Shelf Size': 'Rozmiar półki',
  'Lift/Rack Name': 'Nazwa windy/regału',

  'Bulk': 'Hurtowo',
  'Cross Docking': 'Cross-Docking',
  'Inspections': 'Inspekcje',
  'Locker': 'Szafka',
  'Lockers': 'Szafki',
  'Are you sure you want to delete this lift? All record related to this lift will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć tę windę? Wszystkie dane związane z tą windą zostaną również usunięte. Tej czynności nie można cofnąć.',
  'Delete lift': 'Usuń windę',
  'Add Location': 'Dodaj lokalizację',
  'Location successfully added': 'Lokalizacja dodana pomyślnie',
  'The location is existed': 'Lokalizacja już istnieje',
  'Rack Number': 'Numer regału',
  'Rack Name': 'Nazwa regału',
  'Rack Description': 'Opis regału',
  'Shelves (S)': 'Półki (S)',
  'Compartments (C)': 'Przegrody (C)',
  'Depths (D)': 'Głębokości (D)',
  'Shelf Width (mm)': 'Szerokość półki (mm)',
  'Shelf Depth (mm)': 'Głębokość półki (mm)',
  'No lift found!': 'Nie znaleziono windy!',
  'Required': 'Wymagane',

  'Speed': 'Prędkość',
  'Security Groups': 'Grupy bezpieczeństwa',
  'Notes': 'Notatki',

  'Assign a Shelf map': 'Przypisz mapę półek',
  'I understand': 'Rozumiem',
  'Select the shelf map to assign.': 'Wybierz mapę półek do przypisania.',
  'Actions': 'Akcje',
  'Shelf Map': 'Mapa półek',

  'Add Vertical': 'Dodaj windę',
  'Edit Vertical': 'Edytuj windę',
  'Please Select': 'Proszę wybrać',
  'Lift Group': 'Grupa wind',
  'Lock Timer (seconds)': 'Czas blokady (sekundy)',
  'Number Of Shelves': 'Liczba półek',
  'Shelf Width': 'Szerokość półki',
  'Shelf Depth': 'Głębokość półki',
  'Serial Number': 'Numer seryjny',
  'License Key': 'Klucz licencyjny',
  'Login Required': 'Wymagane logowanie',
  'Manage Articles': 'Zarządzaj artykułami',
  'Auto Generated Article Codes': 'Automatycznie generowane kody artykułów',
  'Use Security': 'Użyj zabezpieczeń',
  'Vertical successfully added. Restart the mpx VLM Services to activate the new lift': 'Winda dodana pomyślnie. Uruchom ponownie usługi MPX VLM, aby aktywować nową windę',
  'Generic Error': 'Błąd ogólny',
  'Access Point': 'Punkt dostępu',
  'Language': 'Język',
  'Controller PC IP address': 'Adres IP kontrolera PC',
  'Label Printer': 'Drukarka etykiet',
  'Printer': 'Drukarka',
  'Article Label Format': 'Format etykiety artykułu',
  'Question 1': 'Pytanie 1',
  'Question 2': 'Pytanie 2',
  'Allow Picking': 'Zezwól na pobieranie',
  'Allow Putting': 'Zezwól na odkładanie',
  'Allow Searching': 'Zezwól na wyszukiwanie',
  'Allow Get Shelf': 'Zezwól na dostęp do półki',
  'Reverse Shelf Map': 'Odwrotna mapa półek',
  'Store After Pick': 'Przechowuj po pobraniu',
  'Store After Job': 'Przechowuj po pracy',
  'Manage Lift': 'Zarządzaj windą',
  'Manage Racking': 'Zarządzaj regałami',
  'Manage Lockers': 'Zarządzaj szafkami',
  'Enable Camera': 'Włącz kamerę',
  'Left Camera': 'Lewa kamera',
  'Right Camera': 'Prawa kamera',
  'Images storage': 'Przechowywanie obrazów',
  'Select images storage': 'Wybierz miejsce przechowywania obrazów',
  'Local Storage': 'Przechowywanie lokalne',
  'AWS S3': 'AWS S3',
  'Local Path': 'Ścieżka lokalna',
  'AWS Bucket Name': 'Nazwa kosza AWS',
  'AWS Dir Name': 'Nazwa katalogu AWS',
  'AWS Region': 'Region AWS',
  'AWS Access Key Id': 'Identyfikator klucza dostępu AWS',
  'AWS Secret Access Key': 'Sekretny klucz dostępu AWS',
  // TODO : orders, pages, resources, shared, components (table, pagination, ...)

  'Put Away': 'Odkładanie',
  'Put Away Value': 'Wartość odkładania',
  'Returns': 'Zwroty',
  'units': 'jednostki',
  'days': 'dni',
  'Oldest Pending Job': 'Najstarsze oczekujące zadanie',
  'Average Orders Per Months': 'Średnia liczba zamówień na miesiąc',
  'Average Pending Time': 'Średni czas oczekiwania',
  'Picks': 'Wybory',
  'Latest Order': 'Najnowsze zamówienie',
  'Oldest Pending': 'Najstarsze oczekujące',
  'Created Date': 'Data utworzenia',
  'Customer': 'Klient',

  'Any question?': 'Jakieś pytania?',
  'Message ...': 'Wiadomość...',
  'Sorry I don\'t understand your question': 'Przepraszam, nie rozumiem twojego pytania',
  'Order History': 'Historia zamówień',
  'Download Template': 'Pobierz szablon',
  'Article Information': 'Informacje o artykule',
  'Drop your file here, or': 'Upuść tutaj swój plik lub',
  'Support': 'Wsparcie',
  'Refresh': 'Odśwież',
  'Export': 'Eksport',
  'Search': 'Szukaj',
  'Total {{number}} Items': 'Łącznie {{number}} przedmiotów',
  'page': 'strona',

  'Copyright': 'Prawa autorskie',
  'Term & Conditions': 'Warunki użytkowania',
  'Privacy & Policy': 'Prywatność i polityka',
  'Profile': 'Profil',
  'Sign Out': 'Wyloguj się',

// update 1/3/2025
  'Priority': 'Priorytet',
  'Completed Orders': 'Zakończone zamówienia',
  'Jobs': 'Zadania',
  'Items': 'Przedmioty',

  'Name': 'Nazwa',
  'Birthday': 'Urodziny',
  'orders': 'zamówienia',
  '(mins)': '(minuty)',
  'per session': 'na sesję',
  'Last Order': 'Ostatnie zamówienie',
  'Total Customers': 'Łączna liczba klientów',
  'Active Customers': 'Aktywni klienci',
  'New Customers': 'Nowi klienci',

  'Batch Code': 'Kod partii',
  'Purchase Order': 'Zamówienie zakupu',
  'Supplier Name': 'Nazwa dostawcy',
  'Receipted': 'Odebrane',
  'Progress': 'Postęp',
  'Bay': 'Zatoka',
  'Next Batch': 'Następna partia',
  'Pending Orders': 'Oczekujące zamówienia',
  'No data': 'Brak danych',
  'Delivery Address': 'Adres dostawy',
  'Date Created': 'Data utworzenia',
  'Date Required': 'Data wymagana',
  'Date Started': 'Data rozpoczęcia',
  'Date Processed/Completed': 'Data przetworzenia/zakończenia',
  'Processing Time': 'Czas przetwarzania',
  'Picked': 'Wybrane',
  'Picker': 'Osoba wybierająca',
  'Qty': 'Ilość',
  'View Carrier Details': 'Pokaż szczegóły przewoźnika',
  'No order found!': 'Nie znaleziono zamówienia!',
  'Rack Picks': 'Wybory z regału',
  'Delete order': 'Usuń zamówienie',
  'Are you sure you want to delete this order? All record related to this order will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć to zamówienie? Wszystkie powiązane z nim dane zostaną również usunięte. Tej czynności nie można cofnąć.',
  'Access Denied!': 'Dostęp zabroniony!',
  'You have no permission to visit this page': 'Nie masz uprawnień do odwiedzenia tej strony',

  'Red': 'Czerwony',
  'Green': 'Zielony',
  'Blue': 'Niebieski',
  'Yellow': 'Żółty',
  'Width (mm)': 'Szerokość (mm)',
  'Depth (mm)': 'Głębokość (mm)',
  'Height (mm)': 'Wysokość (mm)',
  'Weight (kg)': 'Waga (kg)',
  'Volume (m3)': 'Objętość (m3)',
  'Material': 'Materiał',
  'Single Checkbox': 'Pojedynczy checkbox',
  'I agree to the terms and conditions': 'Zgadzam się z warunkami',
  'Clone as rotated bin': 'Sklonuj jako obrócony pojemnik',
  'Bin successfully added': 'Pojemnik dodany pomyślnie',
  'Edit Bin': 'Edytuj pojemnik',
  'Create New Bin': 'Utwórz nowy pojemnik',
  'Delete bin': 'Usuń pojemnik',
  'Are you sure you want to delete this bin? All record related to this bin will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć ten pojemnik? Wszystkie dane z nim związane również zostaną usunięte. Tej czynności nie można cofnąć.',
  'Devices': 'Urządzenia',
  'Options': 'Opcje',
  'Download': 'Pobierz',
  'Upload': 'Prześlij',
  'Description of': 'Opis',
  'List of files': 'Lista plików',
  'Stock On Hand': 'Dostępny zapas',
  'Upload file cannot more then {{size}} kb!': 'Przesłany plik nie może być większy niż {{size}} kb!',
  'Upload successful': 'Przesyłanie zakończone sukcesem',
  'Articles': 'Artykuły',
  'Images': 'Obrazy',
  'Upload a png or jpg file with the file name the same as the article id.': 'Prześlij plik png lub jpg, którego nazwa pliku jest taka sama jak identyfikator artykułu.',
  'Delete Security Group': 'Usuń grupę zabezpieczeń',
  'Are you sure you want to delete this security group?': 'Czy na pewno chcesz usunąć tę grupę zabezpieczeń?',
  'Group Name': 'Nazwa grupy',
  'Group Description': 'Opis grupy',
  'Security Group has been submitted successfully': 'Grupa zabezpieczeń została pomyślnie zgłoszona',
  'Edit {{name}} Group': 'Edytuj grupę {{name}}',
  'Add {{name}} Group': 'Dodaj grupę {{name}}',
  'Assign Users': 'Przypisz użytkowników',
  'Bin Information': 'Informacje o pojemniku',
  'Multiple Product Bin': 'Pojemnik na wiele produktów',
  'ESL Tag': 'Etykieta ESL',
  'Location Name': 'Nazwa lokalizacji',
  'Y position': 'Pozycja Y',
  'X position': 'Pozycja X',
  'Delete {{name}}': 'Usuń {{name}}',
  'Are you sure you want to delete this {{name}}?': 'Czy na pewno chcesz usunąć to {{name}}?',
  'Edit {{name}}': 'Edytuj {{name}}',
  'Add {{name}}': 'Dodaj {{name}}',
  'Search Production': 'Szukaj produkcji',
  'No result': 'Brak wyników',
  'Add bin to the map': 'Dodaj pojemnik do mapy',
  'Add bins to the map': 'Dodaj pojemniki do mapy',
  'Successfully': 'Pomyślnie',
  'The changes you have made, are not saved.': 'Dokonane zmiany nie zostały zapisane.',
  'Do you wish to exit without saving ?': 'Czy chcesz wyjść bez zapisywania?',
  'No': 'Nie',
  'Yes': 'Tak',
  'No shelf map found!': 'Nie znaleziono mapy półek!',
  'The changes you have made, are not saved. Do you wish to exit without saving ?': 'Dokonane zmiany nie zostały zapisane. Czy chcesz wyjść bez zapisywania?',
  'Date Put': 'Data umieszczenia',
  'Serial Numbers': 'Numery seryjne',
  'Serial': 'Seryjny',
  'Are you sure you want to delete this serial number?': 'Czy na pewno chcesz usunąć ten numer seryjny?',
  'Delete serial number': 'Usuń numer seryjny',
  'Add serial number': 'Dodaj numer seryjny',
  'There is no enough space to add this bin': 'Nie ma wystarczającej ilości miejsca, aby dodać ten pojemnik',
  'There is no enough space to add this bin at selected position': 'Nie ma wystarczająco miejsca, aby dodać ten pojemnik w wybranym miejscu',
  'Do you want to clean map?': 'Czy chcesz wyczyścić mapę?',
  'This box can not be deleted.': 'Ten pojemnik nie może zostać usunięty.',
  'Assign Article': 'Przypisz artykuł',
  'Delete Selected Box': 'Usuń wybrany pojemnik',
  'Clear Map': 'Wyczyść mapę',
  'Zoom Out': 'Pomniejsz',
  'Zoom In': 'Powiększ',
  'Zoom': 'Powiększenie',
  'Delete selected': 'Usuń wybrane',
  'Exit fullscreen': 'Zamknij pełny ekran',
  'Fullscreen': 'Pełny ekran',
  'Successfully added': 'Pomyślnie dodano',
  'Must be a number': 'Musi być liczbą',
  'Edit shelf map': 'Edytuj mapę półek',
  'Add new shelf map': 'Dodaj nową mapę półek',
  'Map name': 'Nazwa mapy',
  'Map description': 'Opis mapy',
  'Left Gap': 'Lewa przerwa',
  'Right Gap': 'Prawa przerwa',
  'Top Gap': 'Górna przerwa',
  'Front Gap': 'Przednia przerwa',
  'Rear Gap': 'Tylna przerwa',
  'Divider Gap': 'Przerwa dzieląca',
  'Shelf Number': 'Numer półki',
  'Shelf Name': 'Nazwa półki',
  'Shelf Description': 'Opis półki',
  'Shelf has been submitted successfully': 'Półka została pomyślnie dodana',
  'Edit {{name}} Shelf': 'Edytuj półkę {{name}}',
  'Add {{name}} Shelf': 'Dodaj półkę {{name}}',
  'Assign Shelf': 'Przypisz półkę',
  'Assign Shelf to the map': 'Przypisz półkę do mapy',
  'Saving...': 'Zapisywanie...',
  'Saving': 'Zapisywanie',
  'Are you sure you want to delete this shelf map? All record related to this shelf map will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć tę mapę półek? Wszystkie powiązane z nią dane zostaną również usunięte. Tej czynności nie można cofnąć.',
  'Delete shelf map': 'Usuń mapę półek',
  'Created By': 'Utworzony przez',
  'Add map': 'Dodaj mapę',
  'Templates': 'Szablony',
  'Smart Tag': 'Inteligentna etykieta',
  'Template': 'Szablon',
  'Edit Smart Tag': 'Edytuj inteligentną etykietę',
  'Edit Template': 'Edytuj szablon',
  'Add Smart Tag': 'Dodaj inteligentną etykietę',
  'Add Template': 'Dodaj szablon',
  'Create New Smart Tag': 'Utwórz nową inteligentną etykietę',
  'Mac Address': 'Adres MAC',
  'IP Address': 'Adres IP',
  'Tag successfully added': 'Etykieta pomyślnie dodana',
  'Template Code': 'Kod szablonu',
  'No user found!': 'Nie znaleziono użytkownika!',
  'Invalid email': 'Nieprawidłowy e-mail',
  'User successfully updated': 'Użytkownik pomyślnie zaktualizowany',
  'User has not updated': 'Nie zaktualizowano użytkownika',
  'Basic info, like your name and address that will displayed in public': 'Podstawowe informacje, takie jak imię i adres, które będą publicznie wyświetlane',
  'General': 'Ogólne',
  'User Name': 'Nazwa użytkownika',
  'Updating...': 'Aktualizacja...',
  'RFID/Smart card code': 'Kod karty RFID/Smart',
  'User successfully created': 'Użytkownik pomyślnie utworzony',
  'User has not created': 'Nie utworzono użytkownika',
  'User successfully deleted': 'Użytkownik pomyślnie usunięty',
  'User has not deleted': 'Nie usunięto użytkownika',
  'User successfully enabled': 'Użytkownik pomyślnie włączony',
  'User has not enabled': 'Nie włączono użytkownika',
  'User successfully disabled': 'Użytkownik pomyślnie wyłączony',
  'User has not disabled': 'Nie wyłączono użytkownika',
  'Password Required': 'Wymagane hasło',
  'Enter your new password': 'Wprowadź swoje nowe hasło',
  'Only Letters & Numbers Allowed': 'Dozwolone tylko litery i cyfry',
  'Password not match': 'Hasła nie są zgodne',
  'Enter your current & new password to reset your password': 'Wprowadź swoje aktualne i nowe hasło, aby zresetować hasło',
  'Current Password': 'Aktualne hasło',
  'New Password': 'Nowe hasło',
  'Password has not updated': 'Hasło nie zostało zaktualizowane',
  'Account': 'Konto',
  'UserName': 'Nazwa użytkownika',
  'Successfuly Deleted': 'Pomyślnie usunięto',
  'Product successfuly deleted': 'Produkt pomyślnie usunięty',
  'Add UOM': 'Dodaj jednostkę miary',
  'Edit UOM': 'Edytuj jednostkę miary',
  'Create New UOM': 'Utwórz nową jednostkę miary',
  'Are you sure you want to delete this UOM? All record related to this UOM will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć tę jednostkę miary? Wszystkie dane z nią związane również zostaną usunięte. Tej czynności nie można cofnąć.',
  'Delete UOM': 'Usuń jednostkę miary',
  'UOM successfully deleted': 'Jednostka miary pomyślnie usunięta',
  'UOM has not deleted': 'Jednostka miary nie została usunięta',
  'UOM successfully added': 'Jednostka miary pomyślnie dodana',
  'Do you want to delete "{{zone}}"?': 'Czy chcesz usunąć "{{zone}}"?',
  'Do you want to delete "{{warehouse}}"?': 'Czy chcesz usunąć "{{warehouse}}"?',
  'Warehouse & Zones': 'Magazyny i strefy',
  'Warehouse successfully updated': 'Magazyn pomyślnie zaktualizowany',
  'Zone successfully updated': 'Strefa pomyślnie zaktualizowana',
  'Zone successfully added': 'Strefa pomyślnie dodana',
  'Edit Warehouse': 'Edytuj magazyn',
  'Edit Zone': 'Edytuj strefę',
  'Create New Warehouse': 'Utwórz nowy magazyn',
  'Create New Zone': 'Utwórz nową strefę',
  'Zone successfully deleted': 'Strefa pomyślnie usunięta',
  'Warehouse successfully deleted': 'Magazyn pomyślnie usunięty',
  'Warehouse has not deleted': 'Magazyn nie został usunięty',
  'Zone has not deleted': 'Strefa nie została usunięta',

  'Add to Next Batch': 'Dodaj do następnego zestawu',
  'Add Article': 'Dodaj artykuł',
  'Fixed Location': 'Stała lokalizacja',
  'Total Quantity': 'Całkowita ilość',
  'S-C': 'Półka-przegroda',
  'Blocked': 'Zablokowany',
  'PTL RACK NAME': 'Nazwa regału PTL',
  'Bin Types': 'Typy regałoów',
}
